var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSouthEastFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 170,
    viewBox: "0 0 200 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 90.5L27 91.5L38.5 67.5L46.5 65.5V56.5L60.5 54L61.5 62L105 49L103 52L72.5 90.5Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 91H80V154.902L34.5 128.634V91Z",
    stroke: "#FF0000",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105 50.5L73 87.5V90.5H80V155.5L124.5 132.5V87.5H133L105 50.5Z",
    stroke: "#FF0000",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98 144.5V98.5H111V139L98 144.5Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101.5L50 102.5V120.5L41 119.5V101.5Z",
    fill: "#FF0000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57 103.5L70 105.5V123.5L57 121.5V103.5Z",
    fill: "#FF0000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.184 26.9999C161.186 29.436 160.218 31.772 158.497 33.4956C156.775 35.2192 154.439 36.1872 152.003 36.1888C149.567 36.1888 147.231 35.2223 145.507 33.5002C143.784 31.7782 142.816 29.442 142.816 27.0061C142.816 24.5702 143.782 22.2324 145.506 20.5104C147.228 18.7883 149.564 17.8203 152 17.8203C154.434 17.8203 156.77 18.7868 158.492 20.5088C160.214 22.2294 161.183 24.5652 161.184 26.9999ZM152 12L149.85 15.7257L154.15 15.7273L152 12ZM154.15 38.265H149.85L152 42L154.15 38.265ZM137 26.9999L140.726 29.1498L140.727 24.85L137 26.9999ZM163.265 24.85V29.1498L167 26.9999L163.265 24.85ZM162.608 16.3919L158.451 17.5077L161.492 20.5486L162.608 16.3919ZM145.549 36.5012L142.508 33.4603L141.392 37.6075L145.549 36.5012ZM141.392 16.3919L142.508 20.5487L145.549 17.5077L141.392 16.3919ZM161.501 33.4511L158.46 36.4921L162.617 37.6078L161.501 33.4511Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthEastFace);
export default __webpack_public_path__ + "static/media/SouthEastFace.b35b00bb2e9cc0e499f0b5e63a0b5a05.svg";
export { ForwardRef as ReactComponent };